import React, { ComponentProps, useCallback } from 'react';
import { useSelector } from 'react-redux';
import GenericReportModal from './GenericReportModal';
import GenerateStockTransferReportMutation from '../../graphql/mutations/product/GenerateStockTransferReportMutation.graphql';
import { FilterOperation, IFilterInput, ReportType } from '../../graphql/schema/p4types';
import { IReduxStore } from '../../@types/reduxTypes';
import { useActionProps } from '../../utils/useActionProps';
import FluentModal from './FluentModal';

const STOCK_TRANSFER_TEMPLATE_FILTERS: Array<IFilterInput> = [
  {
    filterOperation: FilterOperation.Equals,
    filterParameters: {
      field: 'reportType',
      value: ReportType.StockTransferReport,
    },
  },
];

const StockTransferReportModal = ({
  isOpen,
  onClose,
  ...props
}: ComponentProps<typeof GenericReportModal> & { isOpen: boolean }) => {
  const actionProps = useActionProps('stockTransfers');

  const email = useSelector((store: IReduxStore) => store.app.user?.email);

  const getInput = useCallback(() => actionProps, [actionProps]);

  return (
    <FluentModal isOpen={isOpen}>
      <div style={{ padding: '1em' }}>
        <GenericReportModal
          {...props}
          templateFilters={STOCK_TRANSFER_TEMPLATE_FILTERS}
          title="Stock Transfer Report"
          input={getInput}
          mutation={GenerateStockTransferReportMutation}
          allowEmailTo={true}
          emailToReadOnly={true}
          onClose={() => onClose?.()}
          emailConfig={{
            emailTo: [{ email: email, label: email }],
          }}
        />
      </div>
    </FluentModal>
  );
};

export default StockTransferReportModal;
